import React from 'react'

import Loader from '../../core/components/Loader'

import '../styles/logged.css';

class LayoutLogged extends React.Component {

    componentDidMount() {
        this.props.retrieveUserFromToken()
    }

    render() {
    	const { user } = this.props

    	if(user.fulfilled){
    		return (
	            <div className="layout-logged fullheight">
	                {this.props.children}
	            </div>
	        )
    	}
        
    	return <Loader />
    }
}


export default LayoutLogged



// WEBPACK FOOTER //
// ./src/user/components/UserLogged.js